import React, { Component } from 'react';
import Category from './helpers/Category';

export default class Stay extends Component {
  lgHeader = {
    id: 'lgHeader',
    src: require('./images/stay/txt_lg_DuringMyStay.png'),
    left: 0,
    width: 732,
    height: 35,
  };
  smHeader = {
    id: 'smHeader',
    src: require('./images/stay/txt_sm_DuringMyStay.png'),
    width: 222,
    height: 222,
  };
  cat1Buttons = [
    {
      id: 'patientPortalSignup',
      to: '/patient_portal_signup',
      highlight: require('./images/mydashboard/txt_SignUpPortal_HL.png'),
      unhighlight: require('./images/mydashboard/txt_SignUpPortal_UH.png'),
      alt: 'Patient Portal Signup',
    },
    {
      id: 'careTeam',
      to: '/care_team',
      highlight: require('./images/stay/txt_CareTeam_HL.png'),
      unhighlight: require('./images/stay/txt_CareTeam_UH.png'),
      alt: 'Care Team',
    },
    // Jira ENGHCAPPS-4387 - remove My Medications (leaving here temporarily in case they want it back)
    // {
    //   id: "myMedications",
    //   to: "/info_confirmation/meds",
    //   highlight: require("./images/stay/txt_MyMedications_HL.png"),
    //   unhighlight: require("./images/stay/txt_MyMedications_UH.png"),
    //   alt: "My Medications",
    // },
    {
      id: 'myAllergies',
      to: '/info_confirmation/allergies',
      highlight: require('./images/stay/txt_MyAllergies_HL.png'),
      unhighlight: require('./images/stay/txt_MyAllergies_UH.png'),
      alt: 'My Allergies',
    },
    // Jira 3483 - remove Pain Monitoring (leaving here temporarily in case they want it back)
    // {
    //   id: "painScale",
    //   to: "/pain_monitoring",
    //   highlight: require("./images/stay/txt_PainScale_HL.png"),
    //   unhighlight: require("./images/stay/txt_PainScale_UH.png"),
    //   alt: "Pain Scale",
    // },
    {
      id: 'dwbControls',
      to: '/dwb_controls',
      highlight: require('./images/stay/txt_DigitalWhiteboard_HL.png'),
      unhighlight: require('./images/stay/txt_DigitalWhiteboard_UH.png'),
      alt: 'DWB Controls',
    },
    {
      id: 'makeArequest',
      to: '/requests',
      highlight: require('./images/stay/txt_MakeRequest_HL.png'),
      unhighlight: require('./images/stay/txt_MakeRequest_UH.png'),
      alt: 'Make A Request',
    },
    // ENGHCAPPS-5077: Remove Bedside Shopping (leaving here in case they want it back)
    // {
    //   id: 'retailShopping',
    //   to: '/retail_shopping',
    //   highlight: require('./images/stay/txt_BedsideShopping_HL.png'),
    //   unhighlight: require('./images/stay/txt_BedsideShopping_UH.png'),
    //   alt: 'Bedside Shopping',
    // },
    {
      id: 'language',
      to: '/languages',
      highlight: require('./images/stay/txt_Language_HL.png'),
      unhighlight: require('./images/stay/txt_Language_UH.png'),
      alt: 'Language',
    },
    {
      id: 'myMessages',
      to: '/messages',
      highlight: require('./images/mydashboard/Txt_MyMessages_HL.png'),
      unhighlight: require('./images/mydashboard/Txt_MyMessages_UH.png'),
      alt: 'My Messages',
    },
  ];

  render() {
    const currentHighlight =
      this.props.current === this.props.movingPos && this.props.current === -1;
    const shrinkMe =
      this.props.current === -1 &&
      (this.props.movingPos === -2 || this.props.movingPos === 0);
    const growMe =
      (this.props.current === 0 || this.props.current === -2) &&
      this.props.movingPos === -1;

    return (
      <Category
        largeHeader={this.lgHeader}
        smallHeader={this.smHeader}
        serviceLinks={this.cat1Buttons}
        shrinkGrow={this.props.shrinkGrow}
        hlState={this.props.hlState}
        movedir={this.props.movedir}
        currentHighlight={currentHighlight}
        shrinkMe={shrinkMe}
        growMe={growMe}
        disabled={this.props.disabled}
      />
    );
  }
}
